import { useMemo } from "react";

import {
  countriesToOptions,
  phoneCodesOptions,
} from "@vega-api/custom/services/country.service";
import { useGetCountryList } from "@vega-api/generated/country-v1/country-v1";
import { type CountryResponse } from "@vega-api/generated/types/countryResponse";
import { DEFAULT_PHONE_CODE } from "@vega-core/constants/global";
import { isFalsy } from "@vega-core/utils/isFalsy";

export function useCountriesOptions() {
  const { data: { data: countriesList = [] } = {} } = useGetCountryList();

  return useMemo(() => {
    const availableSoonCountries =
      [] satisfies CountryResponse[] as CountryResponse[];

    if (isFalsy(countriesList) || countriesList.length === 0) {
      return {
        availableSoonCountries: [],
        countries: [],
        phoneCodes: [DEFAULT_PHONE_CODE],
      };
    }

    return {
      availableSoonCountries: countriesToOptions(availableSoonCountries),
      countries: countriesToOptions(countriesList),
      phoneCodes: phoneCodesOptions(countriesList),
    };
  }, [countriesList]);
}
